// extracted by mini-css-extract-plugin
export default {"toggle":"p7DTQ","tooltip":"_3VhdS","badge-icon":"wE-Zu","badgeIcon":"wE-Zu"};